import React from 'react';

const Donation = () => {
  return (
    <div className="min-h-screen flex items-center justify-center">
      <h1>Donation Page</h1>
    </div>
  );
};

export default Donation;
